/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class BaseApi {
    static getInstance() {
        if (!this.instance) this.instance = new BaseApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取SO同步过滤配置列表，邮箱列表
    async getSOSyncList (param,num,size){
        let url = `/api/system/dictionary/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增SO同步过滤配置，新增经销商逾期邮箱, 新增收件人/抄送人邮箱
    async saveSOSync (param,id){
        let url = `/api/system/dict/sub`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增SO同步过滤配置，新增经销商逾期邮箱, 新增收件人/抄送人邮箱
    async editSOSync (param,id){
        let url = `/api/system/dict/sub/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除SO同步过滤配置，删除邮箱
    async delSOSync (id){
        let url = `/api/system/dict/sub/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取产品列表
    async getProductList (param){
        let url = `/api/product/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取订单来源列表
    async getOrderSourceList (param,num,size){
        let url = `/api/system/source/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取国家列表
    async getCountryList (param,num,size){
        let url = `/api/system/country/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 更新国家代码属性
    async updateCountryCode (param,num,size){
        let url = `/api/system/country/update`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取销售--经销商绑定关系列表
    async getSaleDealerList (param,num,size){
        let url = `/api/system/source/sale/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存销售--经销商绑定关系
    async saveSaleDealer (param){
        let url = `/api/system/source/sale/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除销售--经销商绑定关系
    async deleteSaleDealer (param){
        let url = `/api/system/source/sale/delete?source_ids=${param.source_ids}&user_id=${param.user_id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取经销商
    async getDealer (param){
        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取销售
    async getSale (param){
        let url = `/api/user/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取区域销售管理人配置列表
    async getAreaSaleManagerList (param, num, size){
        let url = `/api/system/dictionary/list?page_num=${num}&page_size=${size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增区域销售经理
    async addAreaSaleManager (param){
        let url = `/api/system/dict/sub`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 编辑区域销售经理
    async editAreaSaleManager (param,id){
        let url = `/api/system/dict/sub/${id}`
        let result = await this.getData(url,param,'PATCH')
        return result
    }

    // 删除区域销售经理
    async delAreaSaleManager (id){
        let url = `/api/system/dict/sub/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 发货日期区间配置列表
    async shipDateRangeList (param, page_num, page_size){
        let url = `/api/system/deliveryBlock/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存编辑发货日期区间配置
    async saveShipDateRange (param){
        let url = `/api/system/deliveryBlock/save`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除发货日期区间配置
    async deleteShipDateRange (id){
        let url = `/api/system/deliveryBlock/delete?id=${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 更新支付折扣
    async updatePayDiscount (param){
        let url = `/api/system/source/payment/discount`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 更新现金折扣
    async updateCashDiscount (param){
        let url = `/api/system/source/payment/with/days/discount`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 更新渠道运费
    async updateFreight (param){
        let url = `/api/system/source/shipping/cost`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取支付折扣下拉配置
    async getPayDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取现金折扣下拉配置
    async getCashDiscountConfig (param){
        let url = `/api/system/dictionary/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 设置折扣比例
    async setDiscountRate (param){
        let url = `/api/system/source/pre/discount`
        let result = await this.getData(url,param,'GET')
        return result
    }

}

export {
    BaseApi
}